import React from "react";
import CTFBarChart from "./charts/CtfCharts/BarChart";
import CTFDonutChart from "./charts/CtfCharts/DonutChart";
import CTFPieChart from "./charts/CtfCharts/PieChart";
import BugBountyBarChart from "./charts/BugBountyCharts/BarChart";
import BugBountyDonutChart from "./charts/BugBountyCharts/DonutChart";
import BugBountyPieChart from "./charts/BugBountyCharts/PieChart";
import Grid from "@mui/joy/Grid";
import { Card, CardContent, Typography } from "@mui/joy";

interface EventStatsProps {
  eventName: string;
  eventCategory: string;
}

const EventStats: React.FC<EventStatsProps> = ({ eventName, eventCategory }) => {
  const isCTF = eventCategory.toLowerCase() === "ctf";

  return (
    <div
      style={{ width: "100%" }}
      className="w-full justify-center items-center"
    >
      <Grid container spacing={2} sx={{ flexGrow: 1 }}>
        <Grid xs={6}>
          <Card
            invertedColors
            sx={{
              borderRadius: "sm",
              p: 2,
              height: "100%",
              overflow: "hidden",
            }}
          >
            <CardContent>
              <Typography level="h2">
                {isCTF ? "Category Breakdown" : "Report Status"}
              </Typography>
            </CardContent>
            {isCTF ? (
              <CTFDonutChart eventName={eventName} />
            ) : (
              <BugBountyDonutChart eventName={eventName} />
            )}
          </Card>
        </Grid>
        <Grid xs={6}>
          <Card
            invertedColors
            sx={{
              borderRadius: "sm",
              p: 2,
              height: "100%",
              overflow: "hidden",
            }}
          >
            <CardContent>
              <Typography level="h2">
                {isCTF ? "Submission Statistics" : "Severity Statistics"}
              </Typography>
            </CardContent>
            <div
              style={{
                width: "95%",
                height: "80%",
                overflow: "auto",
                marginBottom: "1rem",
              }}
            >
              {isCTF ? (
                <CTFPieChart eventName={eventName} />
              ) : (
                <BugBountyPieChart eventName={eventName} />
              )}
            </div>
          </Card>
        </Grid>
        <Grid xs={12}>
          <Card
            invertedColors
            sx={{
              borderRadius: "sm",
              p: 2,
              height: "100%",
              overflow: "hidden",
            }}
          >
            <CardContent>
              <Typography level="h2">Submission Statistics</Typography>
            </CardContent>
            {isCTF ? (
              <CTFBarChart eventName={eventName} />
            ) : (
              <BugBountyBarChart eventName={eventName} />
            )}
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default EventStats;
